
import { Component, Vue, Watch, Ref } from 'vue-property-decorator'
import AdminHeader from './components/AdminHeader.vue'
import AdminSidebar from './components/AdminSidebar.vue'
import ReuseTab from '@/components/reuse-tab/Index.vue'
import { useReuseTabStore } from '@/store/reuse-tab'
import SideGuide from '@/components/side-guide/SideGuide.vue'

@Component({
  components: {
    ReuseTab,
    AdminHeader,
    AdminSidebar,
    SideGuide,
  },
})
export default class MainLayout extends Vue {
  private reuseStore = useReuseTabStore()

  private get padding() {
    return this.backgroundColor === '#fff' ? '16px' : '0'
  }
  /**
   * 点击复用tab标签跳转路由
   */
  private handleChangePath(e: any, route: any) {
    if (typeof route !== 'undefined' && (route.path !== this.$route.path || route.name !== this.reuseStore.to.name)) {
      this.reuseStore.changeTo(route)
      this.$router.push(route)
    }
  }

  /**
   * 处理关闭路由tab
   */
  private handleCloseTab(e: any, route: any) {
    const activeName = this.reuseStore.to.name
    this.reuseStore.remove({
      ...route,
      activeName,
    })
  }
  /**
   * 监控 路由tab to属性，以便正确调整路由
   */
  @Watch('reuseStore.to')
  private watchReuseTabTo(newVal: string, oldVal: string) {
    if (newVal !== undefined && newVal !== null) {
      this.handleChangePath(null, newVal)
    }
  }
  @Watch('reuseStore.to', { immediate: true })
  private routeChange() {
    const r = this.reuseStore.to
    if (r.meta && r.meta.backgroundColor) {
      this.backgroundColor = r.meta.backgroundColor
    } else {
      this.backgroundColor = '#fff'
    }
  }
  private backgroundColor = '#fff'
  private mounted() {
    document.body.addEventListener('keyup', this.listenEnter, false)
  }

  private listenEnter(e) {
    if (e.key === 'Enter') {
      const btn: any = document.querySelector('.table-page-search-submitButtons .ant-btn-primary')
      if (btn) {
        btn.dispatchEvent(new Event('click'))
      }
    }
  }

  private beforeDestroy() {
    document.body.removeEventListener('keyup', this.listenEnter, false)
  }
}
